import {
    DTOCardFormField,
} from 'app/types/form.types'

type SkyMindSyncType = {
    availableInSkyMind: boolean,
    skyMindId: number,
}

const getSkyMindSyncFields = (
    isSkyMindId: boolean,
    availableInSkyMind: boolean,
): DTOCardFormField<keyof SkyMindSyncType>[] => {
    return [{
        id: 'SkyMindSync',
        title: 'SkyMind Sync',
        fields: [
            {
                name: 'availableInSkyMind',
                componentName: 'Switch',
                disabled: isSkyMindId,
                labelKey: 'Company.availableInSkyMind',
            },
            {
                name: 'skyMindId',
                componentName: 'InputSingleline',
                disabled: !availableInSkyMind || isSkyMindId,
                labelKey: 'Company.skyMindId',
            },
        ],
    }]
}

export default getSkyMindSyncFields
